'use strict';

exports.__esModule = true;
exports.transformPracticeInsurers = exports.transformSpecialist = exports.transformBlogPosts = exports.transformProfessionalBody = exports.transformInsurers = exports.filterPracticesByEmail = exports.transformPractices = exports.transformProfilePeerRecommendations = exports.transformProfileReviews = exports.transformConsultationFees = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _orderBy = require('lodash/orderBy');

var _orderBy2 = _interopRequireDefault(_orderBy);

var _bookAppointmentSection = require('../reducers/book-appointment-section');

var _doctifyUtils = require('doctify-utils');

var _utils = require('../utils/utils');

var _constants = require('../utils/constants');

var _helpers = require('../../../../src/client/utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var specialtyMapping = function specialtyMapping(specialties, specialtyId) {
  for (var _iterator = specialties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var specialty = _ref;

    if (specialty.id === specialtyId) {
      return specialty;
    }
  }
  return null;
};

var transformConsultationFees = exports.transformConsultationFees = function transformConsultationFees(consultationFees) {
  return consultationFees && consultationFees.length > 0 ? consultationFees.map(function (feeInfo) {
    var consultation = feeInfo.consultation.toLowerCase();
    return {
      consultation: consultation === 'new' || consultation === 'new appointment' ? 'New appointment' : 'Follow-up appointment',
      fee: feeInfo.fee
    };
  }) : [];
};

var transformProfileReviews = exports.transformProfileReviews = function transformProfileReviews(reviews) {
  return reviews.map(function (review) {
    return {
      reviewDate: _moment2.default.utc(review.timestamp_created).format('DD-MM-YYYY'),
      review: review.review.body,
      numberOfStars: review.aggregate_score,
      ratings: (0, _extends3.default)({}, review.review.starRating),
      isVerified: review.is_verified,
      keywords: review.review.reasonKeywords.map(function (keyword) {
        return keyword.name;
      }),
      liked: !!review.review.liked,
      likes: review.review.likes,
      id: review.id,
      comment: review.review && review.review.comments && review.review.comments.appointment_comments && review.review.comments.appointment_comments[0]
    };
  });
};

var transformProfilePeerRecommendations = exports.transformProfilePeerRecommendations = function transformProfilePeerRecommendations() {
  var peerRecommendations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return peerRecommendations.map(function (peerRecommendation) {
    var specialty = (peerRecommendation.keywords || []).filter(function (keyword) {
      return keyword.keyword_type === 'specialty';
    })[0];
    specialty = specialty ? specialty.name : null;
    var conditions = (peerRecommendation.keywords || []).filter(function (keyword) {
      return keyword.keyword_type === 'condition';
    }).map(function (keyword) {
      return keyword.name;
    }).join(', ');
    var procedures = (peerRecommendation.keywords || []).filter(function (keyword) {
      return keyword.keyword_type === 'procedure';
    }).map(function (keyword) {
      return keyword.name;
    }).join(', ');
    var authorName = [peerRecommendation.recommender_title, peerRecommendation.recommender_firstname, peerRecommendation.recommender_lastname].join(' ');
    return {
      recommendationDate: peerRecommendation.timestamp_created,
      recommendationText: peerRecommendation.recommendation,
      authorProfileImage: peerRecommendation.recommender_profile_image + '_lg.jpg',
      authorName: authorName,
      specialty: specialty,
      conditions: conditions,
      procedures: procedures,
      connection: peerRecommendation.connection,
      specialistUri: peerRecommendation.recommender_uri_id
    };
  });
};

/**
 * Returns true if the practice is valid, that is if it's approved or verified.
 * @param {!Object} practice A practice.
 * @return {boolean} true if the practice status is approved or verified.
 */
var isValidPractice = function isValidPractice(practice) {
  return ['approved', 'verified'].includes(practice.practice_status);
};

var transformPractices = exports.transformPractices = function transformPractices(practices, videoConsultation, hospitalList, network) {
  var results = (practices || []).filter(isValidPractice).map(function (practice) {
    var location = void 0;
    if (practice && practice.practice && practice.practice.address && practice.practice.address.geolocation) {
      var geolocation = (JSON.parse(practice.practice.address.geolocation) || {}).coordinates;
      location = {
        lat: geolocation.length ? geolocation[1] : undefined,
        lng: geolocation.length ? geolocation[0] : undefined
      };
    }

    return {
      postcode: practice.practice.address.postcode,
      street1: practice.practice.address.street1,
      city: practice.practice.address.city,
      practiceUri: practice.practice_uri,
      name: practice.practice.name,
      id: practice.practice.id,
      location: location,
      relationships: practice.practice.relationships || [],
      isNhs: practice.practice.is_nhs,
      status: practice.practice.status,
      averageRating: practice.practice_average_review,
      reviewsCount: practice.practice_number_of_reviews,
      insurers: transformPracticeInsurers(practice.practice.insurers),
      networks: practice.practice.networks
    };
  }).filter(function (practice) {
    return videoConsultation ? true : practice.practiceUri !== 'video_consultation';
  }).filter(function (practice) {
    return hospitalList ? videoConsultation && practice.practiceUri === 'video_consultation' || practice.insurers.some(function (insurer) {
      return insurer.id === hospitalList || network;
    }) : true;
  }).filter(function (practice) {
    return network ? practice.networks.includes(network) : true;
  });

  if (results.length === 1 && results[0].practiceUri === 'video_consultation') {
    results = [];
  }

  return results;
};

var filterPracticesByEmail = exports.filterPracticesByEmail = function filterPracticesByEmail(practices) {
  return practices.filter(function (practice) {
    return practice.practiceHasContactDetailsEmails;
  });
};

var getItemById = function getItemById(array, id) {
  for (var _iterator2 = array, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
    var _ref2;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref2 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref2 = _i2.value;
    }

    var item = _ref2;

    if (item.id && id && (item.id === id || item.id.toString() === id.toString())) {
      return item;
    }
  }
  return null;
};
var transformInsurers = exports.transformInsurers = function transformInsurers() {
  var insurers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedInsurers = arguments[1];

  return (selectedInsurers || []).map(function (insurer) {
    var matchedInsurer = getItemById(insurers, insurer.id);
    return {
      url: matchedInsurer && matchedInsurer.icon_uri,
      website: insurer.website
    };
  });
};

var transformProfessionalBody = exports.transformProfessionalBody = function transformProfessionalBody(bodies, selectedBodies) {
  return (selectedBodies || []).map(function (selectedBody) {
    return {
      body: getItemById(bodies, selectedBody.body) && getItemById(bodies, selectedBody.body).name,
      registrationNumber: selectedBody.number || selectedBody.registration_number
    };
  });
};

var transformBlogPosts = exports.transformBlogPosts = function transformBlogPosts(posts) {
  return (posts || []).map(function (post) {
    return {
      slug: post.slug,
      title: post.title.rendered
    };
  });
};

var transformSpecialist = exports.transformSpecialist = function transformSpecialist(specialist, practices, specialties, hospitalList, network) {
  var specialty = (0, _doctifyUtils.extractTopLevelSpecialty)(specialist.specialties) || undefined;

  var videoConsultation = (0, _helpers.isVideoConsultationAvailable)(specialist);
  var specialistPractices = [_bookAppointmentSection.allPracticesObject].concat(transformPractices(practices, videoConsultation, hospitalList, network));

  var specialistNetwork = network && specialist.networks && specialist.networks.find(function (item) {
    return item === network;
  });

  return (0, _extends3.default)({}, specialist, {
    languages: specialist && (specialist.languages || []).reduce(function (languages, language) {
      return '' + languages + (languages.length && ', ' || '') + (language.name || '');
    }, ''),
    attributes: specialist.attributes,
    averageRating: specialist.average_review,
    id: specialist.id,
    doctify_id: specialist.doctify_id || specialist.doctify_id,
    authorId: specialist.author_id,
    education: specialist.attributes && specialist.attributes.education,
    name: specialist.name,
    procedures: specialist.attributes && specialist.attributes.procedures,
    consultationFees: specialist.attributes && transformConsultationFees(specialist.attributes.consultation_fees),
    specialInterests: specialist.attributes && specialist.attributes.special_interests,
    practices: specialistPractices && specialistPractices.length && specialistPractices.length > 1 ? specialistPractices : [],
    selectedPractice: _bookAppointmentSection.allPracticesObject,
    profileImage: specialist.attributes && specialist.attributes.profile_featured_image && specialist.attributes.profile_featured_image + '_lg.jpg',
    qualifications: specialist.suffix,
    hasRequestAppointment: specialist.has_request_appointment && specialist.isCore && specialist.hasContactDetailsEmails && !specialistNetwork,
    hasBooking: specialist.has_booking,
    insurers: specialist.insurers,
    professionalRegistry: specialist.professional_registry,
    specialty: specialty && specialty.name,
    specialtyIcon: specialty && specialtyMapping(specialties, specialty.id) && specialtyMapping(specialties, specialty.id).icon_uri,
    subspecialties: (0, _doctifyUtils.extractSubSpecialties)(specialist.specialties),
    contactNumbers: specialist.contact_numbers,
    about: specialist.attributes && specialist.attributes.about,
    isCore: specialist.isCore,
    isAHG: specialist.isAhg,
    videoConsultation: videoConsultation,
    originalPractices: practices,
    conditionsKeywords: (0, _orderBy2.default)(specialist.conditionsKeywords, 'sortOrder', 'asc'),
    proceduresKeywords: (0, _orderBy2.default)(specialist.proceduresKeywords, 'sortOrder', 'asc'),
    network: specialistNetwork
  });
};

var transformPracticeInsurers = exports.transformPracticeInsurers = function transformPracticeInsurers() {
  var insurers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return insurers.map(function (insurer) {
    return {
      id: insurer.id,
      name: (0, _utils.getInsurerAbbreviation)(insurer.id, _constants.INSURERS_SHORT_NAME_DICTIONARY),
      description: insurer.name + ' Hospital List'
    };
  });
};


// WEBPACK FOOTER //
// ./components/specialist-page/lib/transformers/specialist-profile.js